module.exports = __webpack_public_path__ + "static/media/pdfIcon.ac5ad481.png";